module.exports = __webpack_public_path__ + "img/delete.6fc2c686.png";